module.exports = __webpack_public_path__ + "static/media/editor-admin-open.f2d15130.svg";